@if (!isSingleLineEditor) {
  <div [id]="uniqueId">
    <span matTooltip="Size" class="ql-formats">
      <select class="ql-size">
        <option value="0.75em">Small</option>
        <option selected>Normal</option>
        <option value="1.5em">Large</option>
        <option value="2.5em">Huge</option>
      </select>
    </span>
    <span class="ql-formats">
      <button type="button" matTooltip="Bold" matTooltipPosition="above" class="ql-bold richtext_icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="56" viewBox="0 0 48 56" fill="none">
          <path
            d="M4 0C1.7875 0 0 1.7875 0 4C0 6.2125 1.7875 8 4 8H8V48H4C1.7875 48 0 49.7875 0 52C0 54.2125 1.7875 56 4 56H32C40.8375 56 48 48.8375 48 40C48 34.1875 44.9 29.0875 40.25 26.2875C42.5875 23.5 44 19.9125 44 16C44 7.1625 36.8375 0 28 0H4ZM36 16C36 20.4125 32.4125 24 28 24H16V8H28C32.4125 8 36 11.5875 36 16ZM16 48V32H32C36.4125 32 40 35.5875 40 40C40 44.4125 36.4125 48 32 48H16Z"
            fill="black" />
        </svg>
      </button>
      <button type="button" matTooltip="Italic" matTooltipPosition="above" class="ql-italic richtext_icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="56" viewBox="0 0 48 56" fill="none">
          <path
            d="M16 2C16 0.9 16.9 0 18 0H46C47.1 0 48 0.9 48 2C48 3.1 47.1 4 46 4H34.425L17.8125 52H30C31.1 52 32 52.9 32 54C32 55.1 31.1 56 30 56H2C0.9 56 0 55.1 0 54C0 52.9 0.9 52 2 52H13.575L30.1875 4H18C16.9 4 16 3.1 16 2Z"
            fill="black" />
        </svg>
      </button>
      <button class="ql-underline richtext_icon" matTooltip="Underline" matTooltipPosition="above">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="64" viewBox="0 0 48 64" fill="none">
          <path
            d="M0 2C0 0.9 0.9 0 2 0H14C15.1 0 16 0.9 16 2C16 3.1 15.1 4 14 4H10V30C10 37.7375 16.2625 44 24 44C31.7375 44 38 37.7375 38 30V4H34C32.9 4 32 3.1 32 2C32 0.9 32.9 0 34 0H46C47.1 0 48 0.9 48 2C48 3.1 47.1 4 46 4H42V30C42 39.9375 33.9375 48 24 48C14.0625 48 6 39.9375 6 30V4H2C0.9 4 0 3.1 0 2ZM2 60H46C47.1 60 48 60.9 48 62C48 63.1 47.1 64 46 64H2C0.9 64 0 63.1 0 62C0 60.9 0.9 60 2 60Z"
            fill="black" />
        </svg>
      </button>
      <button class="ql-strike richtext_icon" matTooltip="Strike-through" matTooltipPosition="above">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="56" viewBox="0 0 64 56" fill="none">
          <path
            d="M12 14.45C12 6.475 18.475 0 26.45 0H48C49.1 0 50 0.9 50 2C50 3.1 49.1 4 48 4H26.45C20.675 4 16 8.675 16 14.45C16 19.5625 19.7 23.925 24.7375 24.7625L39.925 27.3C40.85 27.45 41.7375 27.6875 42.5875 28.0125L62 28C63.1 28 64 28.9 64 30C64 31.1 63.1 32 62 32H2C0.9 32 0 31.1 0 30C0 28.9 0.9 28 2 28H21.4125C15.85 25.9375 12 20.5875 12 14.45ZM47.375 38H51.55C51.8375 39.1375 51.9875 40.325 51.9875 41.55C51.9875 49.525 45.5125 56 37.5375 56H16C14.9 56 14 55.1 14 54C14 52.9 14.9 52 16 52H37.55C43.325 52 48 47.325 48 41.55C48 40.3125 47.7875 39.1125 47.375 38Z"
            fill="black" />
        </svg>
      </button>
      <button class="ql-list richtext_icon" matTooltip="Bullet list" matTooltipPosition="above" value="bullet">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="46" viewBox="0 0 64 46" fill="none">
          <path
            d="M3.00146 0C2.20582 0 1.44275 0.31607 0.880144 0.878679C0.317535 1.44129 0.00146484 2.20435 0.00146484 3C0.00146484 3.79565 0.317535 4.55871 0.880144 5.12132C1.44275 5.68393 2.20582 6 3.00146 6C3.79711 6 4.56018 5.68393 5.12279 5.12132C5.68539 4.55871 6.00146 3.79565 6.00146 3C6.00146 2.20435 5.68539 1.44129 5.12279 0.878679C4.56018 0.31607 3.79711 0 3.00146 0ZM18.0015 1C16.9015 1 16.0015 1.9 16.0015 3C16.0015 4.1 16.9015 5 18.0015 5H62.0015C63.1015 5 64.0015 4.1 64.0015 3C64.0015 1.9 63.1015 1 62.0015 1H18.0015ZM18.0015 21C16.9015 21 16.0015 21.9 16.0015 23C16.0015 24.1 16.9015 25 18.0015 25H62.0015C63.1015 25 64.0015 24.1 64.0015 23C64.0015 21.9 63.1015 21 62.0015 21H18.0015ZM18.0015 41C16.9015 41 16.0015 41.9 16.0015 43C16.0015 44.1 16.9015 45 18.0015 45H62.0015C63.1015 45 64.0015 44.1 64.0015 43C64.0015 41.9 63.1015 41 62.0015 41H18.0015ZM6.00146 23C6.00146 22.2044 5.68539 21.4413 5.12279 20.8787C4.56018 20.3161 3.79711 20 3.00146 20C2.20582 20 1.44275 20.3161 0.880144 20.8787C0.317535 21.4413 0.00146484 22.2044 0.00146484 23C0.00146484 23.7956 0.317535 24.5587 0.880144 25.1213C1.44275 25.6839 2.20582 26 3.00146 26C3.79711 26 4.56018 25.6839 5.12279 25.1213C5.68539 24.5587 6.00146 23.7956 6.00146 23ZM3.00146 40C2.20582 40 1.44275 40.3161 0.880144 40.8787C0.317535 41.4413 0.00146484 42.2043 0.00146484 43C0.00146484 43.7957 0.317535 44.5587 0.880144 45.1213C1.44275 45.6839 2.20582 46 3.00146 46C3.79711 46 4.56018 45.6839 5.12279 45.1213C5.68539 44.5587 6.00146 43.7957 6.00146 43C6.00146 42.2043 5.68539 41.4413 5.12279 40.8787C4.56018 40.3161 3.79711 40 3.00146 40Z"
            fill="black" />
        </svg>
      </button>
      <button class="ql-list richtext_icon" matTooltip="Bullet list" matTooltipPosition="above" value="ordered">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="46" viewBox="0 0 64 46" fill="none">
          <path
            d="M3.00146 0C2.20582 0 1.44275 0.31607 0.880144 0.878679C0.317535 1.44129 0.00146484 2.20435 0.00146484 3C0.00146484 3.79565 0.317535 4.55871 0.880144 5.12132C1.44275 5.68393 2.20582 6 3.00146 6C3.79711 6 4.56018 5.68393 5.12279 5.12132C5.68539 4.55871 6.00146 3.79565 6.00146 3C6.00146 2.20435 5.68539 1.44129 5.12279 0.878679C4.56018 0.31607 3.79711 0 3.00146 0ZM18.0015 1C16.9015 1 16.0015 1.9 16.0015 3C16.0015 4.1 16.9015 5 18.0015 5H62.0015C63.1015 5 64.0015 4.1 64.0015 3C64.0015 1.9 63.1015 1 62.0015 1H18.0015ZM18.0015 21C16.9015 21 16.0015 21.9 16.0015 23C16.0015 24.1 16.9015 25 18.0015 25H62.0015C63.1015 25 64.0015 24.1 64.0015 23C64.0015 21.9 63.1015 21 62.0015 21H18.0015ZM18.0015 41C16.9015 41 16.0015 41.9 16.0015 43C16.0015 44.1 16.9015 45 18.0015 45H62.0015C63.1015 45 64.0015 44.1 64.0015 43C64.0015 41.9 63.1015 41 62.0015 41H18.0015ZM6.00146 23C6.00146 22.2044 5.68539 21.4413 5.12279 20.8787C4.56018 20.3161 3.79711 20 3.00146 20C2.20582 20 1.44275 20.3161 0.880144 20.8787C0.317535 21.4413 0.00146484 22.2044 0.00146484 23C0.00146484 23.7956 0.317535 24.5587 0.880144 25.1213C1.44275 25.6839 2.20582 26 3.00146 26C3.79711 26 4.56018 25.6839 5.12279 25.1213C5.68539 24.5587 6.00146 23.7956 6.00146 23ZM3.00146 40C2.20582 40 1.44275 40.3161 0.880144 40.8787C0.317535 41.4413 0.00146484 42.2043 0.00146484 43C0.00146484 43.7957 0.317535 44.5587 0.880144 45.1213C1.44275 45.6839 2.20582 46 3.00146 46C3.79711 46 4.56018 45.6839 5.12279 45.1213C5.68539 44.5587 6.00146 43.7957 6.00146 43C6.00146 42.2043 5.68539 41.4413 5.12279 40.8787C4.56018 40.3161 3.79711 40 3.00146 40Z"
            fill="black" />
        </svg>
      </button>
    </span>
    <span class="ql-formats">
      <button
        type="button"
        class="ql-indent richtext_icon"
        matTooltip="Decrease indent"
        matTooltipPosition="above"
        value="-1">dedent</button>
      <button
        type="button"
        class="ql-indent richtext_icon"
        matTooltip="Increase indent"
        matTooltipPosition="above"
        value="+1">indent</button>
    </span>
    <span class="ql-formats" matTooltip="Alignment" matTooltipPosition="above">
      <select class="ql-align" value="left">
        <option selected></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
      </select>
    </span>
    <span class="ql-formats">
      <button
        type="button"
        matTooltip="Link"
        class="ql-button richtext_icon"
        [matMenuTriggerFor]="linkMenu"
        matTooltipPosition="below">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" viewBox="0 0 72 50" fill="none">
          <path
            d="M42.6375 4.54995C43.6625 5.41245 44.6 6.36245 45.4625 7.38745C47.9375 5.21245 51.125 3.99995 54.4375 3.99995C61.925 3.99995 68 10.075 68 17.5625C68 21.1625 66.575 24.6 64.025 27.15L54.1375 37.0374C51.6 39.5749 48.15 41.0125 44.55 41.0125C37.0625 41.0125 30.9875 34.9375 30.9875 27.45C30.9875 25.5 31.4125 23.5875 32.2 21.8375C32.6625 20.8375 32.2125 19.65 31.2125 19.1875C30.2125 18.725 29.025 19.175 28.5625 20.175C27.5375 22.4375 26.9875 24.9125 26.9875 27.45C26.9875 37.15 34.85 45.0125 44.55 45.0125C49.2 45.0125 53.675 43.1624 56.9625 39.875L66.85 29.9875C70.1375 26.7 71.9875 22.225 71.9875 17.575C71.9875 7.87495 64.125 0.0124512 54.425 0.0124512C50.05 0.0124512 45.85 1.64995 42.625 4.57495L42.6375 4.54995ZM27.4375 8.98745C34.925 8.98745 41 15.0625 41 22.55C41 24.5 40.575 26.4125 39.7875 28.1625C39.325 29.1625 39.775 30.35 40.775 30.8125C41.775 31.275 42.9625 30.825 43.425 29.825C44.45 27.5625 45 25.0875 45 22.55C45 12.85 37.1375 4.98745 27.4375 4.98745C22.7875 4.98745 18.3125 6.83745 15.025 10.125L5.1375 20.0125C1.85 23.3 0 27.775 0 32.4249C0 42.125 7.8625 49.9874 17.5625 49.9874C21.9375 49.9874 26.1375 48.3499 29.3625 45.4249C28.3375 44.5625 27.4 43.6124 26.5375 42.5874C24.0625 44.7624 20.875 45.9749 17.5625 45.9749C10.075 45.9749 4 39.8999 4 32.4124C4 28.8124 5.425 25.375 7.975 22.825L17.8625 12.9375C20.4 10.4 23.85 8.96245 27.45 8.96245L27.4375 8.98745Z"
            fill="black" />
        </svg>
      </button>
    </span>
    <span class="ql-formats">
      <button
        type="button"
        matTooltip="Merge Fields"
        class="ql-button richtext_icon"
        [matMenuTriggerFor]="menu"
        matTooltipPosition="above">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="56" viewBox="0 0 73 56" fill="none">
          <path
            d="M18.9875 0C13.4625 0 8.98749 4.475 8.98749 10V16.6875C8.98749 18.275 8.34999 19.8 7.22499 20.925L1.57499 26.5875C1.19999 26.9625 0.987488 27.475 0.987488 28C0.987488 28.525 1.19999 29.0375 1.57499 29.4125L7.23749 35.075C8.36249 36.2 8.99999 37.725 8.99999 39.3125L8.98749 46C8.98749 51.525 13.4625 56 18.9875 56H26.9875C28.0875 56 28.9875 55.1 28.9875 54C28.9875 52.9 28.0875 52 26.9875 52H18.9875C15.675 52 12.9875 49.3125 12.9875 46V39.3125C12.9875 36.6625 11.9375 34.1125 10.0625 32.2375L5.81249 28L10.0625 23.7625C11.9375 21.8875 12.9875 19.3375 12.9875 16.6875V10C12.9875 6.6875 15.675 4 18.9875 4H26.9875C28.0875 4 28.9875 3.1 28.9875 2C28.9875 0.9 28.0875 0 26.9875 0H18.9875ZM54.9875 0H46.9875C45.8875 0 44.9875 0.9 44.9875 2C44.9875 3.1 45.8875 4 46.9875 4H54.9875C58.3 4 60.9875 6.6875 60.9875 10V16.6875C60.9875 19.3375 62.0375 21.8875 63.9125 23.7625L68.15 28L63.9125 32.2375C62.0375 34.1125 60.9875 36.6625 60.9875 39.3125V46C60.9875 49.3125 58.3 52 54.9875 52H46.9875C45.8875 52 44.9875 52.9 44.9875 54C44.9875 55.1 45.8875 56 46.9875 56H54.9875C60.5125 56 64.9875 51.525 64.9875 46V39.3125C64.9875 37.725 65.625 36.2 66.75 35.075L72.4125 29.4125C72.7875 29.0375 73 28.525 73 28C73 27.475 72.7875 26.9625 72.4125 26.5875L66.75 20.925C65.625 19.8 64.9875 18.275 64.9875 16.6875V10C64.9875 4.475 60.5125 0 54.9875 0Z"
            fill="black" />
        </svg>
      </button>
    </span>
  </div>
}
<quill-editor
  [modules]="quillModules"
  (onEditorCreated)="onEditorCreated($event)"
  [class.textarea-mode]="!isSingleLineEditor">
</quill-editor>
@if (maxLength > 0) {
  <div class="character-counter">
    <span [class.over-limit]="currentCharCount > maxLength">{{ currentCharCount }}/{{ maxLength }} characters</span>
  </div>
}
<mat-menu #menu="matMenu">
  @for (node of mergeFieldListArray; track $index) {
    <button mat-menu-item [matMenuTriggerFor]="triggerMenu" style="padding: 0">
      {{ node.name }}
    </button>
    <mat-menu #triggerMenu="matMenu">
      @for (mergefield of node.mergeFields; track $index) {
        <button mat-menu-item (click)="insertMergeField(mergefield)">{{ mergefield.displayName }}</button>
      }
    </mat-menu>
  }
</mat-menu>

<mat-menu #linkMenu="matMenu">
  <div class="link-input-container">
    <div class="input-group">
      <label class="link-label" id="link-page-label" for="link-page-input">Link Address</label>
        <input
          id="link-page-input"
          matInput
          class="link-input"
          type="url"
          [(ngModel)]="linkUrl"
          #linkUrlModel="ngModel"
          (click)="$event.stopPropagation()"
          placeholder="https://example.com"
          [attr.data-pw]="'link-address'"
          required />
    </div>
    <div class="input-group">
      <label class="link-label" for="link-text-input">Link Text</label>
      <input
        id="link-text-input"
        matInput
        class="link-input"
        [(ngModel)]="linkText"
        #linkTextModel="ngModel"
        (click)="$event.stopPropagation()"
        placeholder="Enter link text"
        [attr.data-pw]="'name'"
        required />
    </div>
    <button
      (click)="insertLink(linkUrlModel, linkTextModel)"
      mat-menu-item
      class="insert-button"
      [disabled]="!linkText.trim() || !isValidLinkUrl()">
      Insert Link
    </button>
  </div>
</mat-menu>
